import { Text } from "@cjdev-internal/visual-stack-x/Text";
import React from "react";

export const TruncatedText = ({ children = "", limit = 30, ...restProps }) => (
  <Text {...restProps}>
    {children.length > limit ? `${children.substring(0, limit)}...` : children}
  </Text>
);
